import { render, staticRenderFns } from "./UserInformationField.vue?vue&type=template&id=58f765e0&scoped=true&"
import script from "./UserInformationField.vue?vue&type=script&lang=ts&"
export * from "./UserInformationField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f765e0",
  null
  
)

export default component.exports